$(document).ready(function () {
    $('.btn.btn-ajax').on('click', function (_event) {

        _event.preventDefault();

        var _that = $(this);

        var url = _that.attr('href');
        var method = _that.data('method') || 'post';
        var form = _that.data('form') || null;

        var data = null;
        if (form) {
            data = $(form).serialize();
        }

        var success = _that.data('success') || '';
        var confirm = _that.data('confirm') || '';
        var error = _that.data('error') || '';

        _that.addClass('disabled');

        var confirmDialog = fetch(confirm);
        if (confirmDialog) {
            dialog(confirmDialog, true);
        } else {
            ajax();
        }

        function ajax() {
            $.ajax({
                url: url,
                method: method,
                data: data,
                success: function (data) {
                    var successDialog = fetch(success);
                    if (successDialog) {
                        dialog(successDialog);
                    }
                },
                error: function (data) {
                    var errorDialog = fetch(error);
                    if (errorDialog) {
                        dialog(errorDialog);
                    }
                }
            });
        }

        function fetch(selector) {
            var _dialog = $(selector);
            if (_dialog.length) {
                return {
                    title: _dialog.data('title') || '',
                    message: _dialog.html() || '',
                    confirm: _dialog.data('confirm') || 'OK'
                };
            }
            return false;
        }

        function dialog(data, doAjaxAfterConfirm) {
            bootbox.dialog({
                message: data.message,
                title: data.title,
                buttons: {
                    confirm: {
                        label: data.confirm,
                        className: "btn-primary",
                        callback: function () {
                            //_that.removeClass('disabled');
                            if (doAjaxAfterConfirm) {
                                ajax();
                            }
                        }
                    }
                }
            });
        }
    });
});